<ion-menu content-id="main" side="start">
  <ion-content>
    @if (isManagerOrReporter()) {
      <div class="list-item">
        <h6 class="v-center">{{ 'notification' | transloco }}</h6>
        <pf-counter [showLabels]="false" />
      </div>
    }
    <ion-item (click)="goToHome()" lines="full">
      <h6 class="v-center">{{ 'home.title' | transloco }}</h6>
      <ion-avatar slot="end">
        <svg-icon src="assets/svg/icon-nav-home.svg" />
      </ion-avatar>
    </ion-item>
    @for (ft of feedbackTypes()?.list; track ft) {
      <ion-item (click)="goToHistoryByType(ft?.code ?? '')" detail="false"
        lines="full">
        <h6 class="v-center">{{ 'opened' | transloco }} {{ ft.description }}</h6>
        <ion-avatar slot="end">
          <ion-img src="assets/icon/{{ft?.code}}_icon.png"></ion-img>
        </ion-avatar>
      </ion-item>
    }
    <ion-item (click)="goToHistory()" lines="full" detail="false">
      <h6 class="v-center">{{ 'home.history' | transloco }}</h6>
      <ion-avatar slot="end">
        <svg-icon src="assets/svg/icon-nav-history.svg" />
      </ion-avatar>
    </ion-item>
    <ion-item (click)="goToArchive()" lines="full" detail="false">
      <h6 class="v-center">{{ 'home.archive' | transloco }}</h6>
      <ion-avatar slot="end">
        <svg-icon src="assets/svg/icon-nav-archive.svg" />
      </ion-avatar>
    </ion-item>
    @if (isServiceDeskOrAdmin()) {
      <ion-item (click)="goToHistoryToManager()" lines="full" detail="false">
        <h6 class="v-center">{{ 'home.history_manager' | transloco }}</h6>
        <ion-avatar slot="end">
          <svg-icon src="assets/svg/icon-nav-history.svg" />
        </ion-avatar>
      </ion-item>
      <ion-item (click)="goToArchiveToManager()" lines="full" detail="false">
        <h6 class="v-center">{{ 'home.archive_manager' | transloco }}</h6>
        <ion-avatar slot="end">
          <svg-icon src="assets/svg/icon-nav-archive.svg" />
        </ion-avatar>
      </ion-item>
    }
    @if (isAdministrator()) {
      <ion-item (click)="navigate('/user-manager')"
        detail="false" lines="full">
        <h6 class="v-center">{{ 'userManager.title' | transloco }}</h6>
        <ion-avatar slot="end">
          <svg-icon src="assets/svg/icon-nav-admin.svg" />
        </ion-avatar>
      </ion-item>
    }
    <ion-item (click)="logout()" lines="full">
      <h6 class="v-center">{{ 'logout' | transloco }}</h6>
      <ion-avatar slot="end">
        <svg-icon src="assets/svg/icon-nav-logout.svg" />
      </ion-avatar>
    </ion-item>

    <ion-item lines="none" class="version">
      <h6>v. {{appVersion}}</h6>
    </ion-item>
  </ion-content>
</ion-menu>
